import { useEventStore } from "store";
import ReactDOM from "react-dom";

interface FeedModalProps {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
}

export function FeedModal({ children, onClose, isOpen }: FeedModalProps) {
  const { theme } = useEventStore();
  if (!isOpen) return null;
  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      id="base-modal-overlay"
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center px-0 z-40"
    >
      <div
        id="base-modal-wrapper"
        onClick={(e) => e.stopPropagation()}
        className={`relative mx-5 shadow-xl flex flex-col items-center card ${theme.card} ${theme.background} w-full z-50 max-h-full overflow-auto`}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
